
















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { MovableTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import MovableTextBoxObject from "../../../document/editor/objects/MovableTextBoxObject.vue";
import MovableTextBoxInputMethodSelector from "../inputMethodEditors/MovableTextBoxInputMethodSelector.vue";
import ClipboardMenu from "./ClipboardMenu.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";

@Component({
  components: {
    ClipboardMenu,
    MovableTextBoxInputMethodSelector,
    ObjectMenuButton,
  }
})
export default class MovableTextObjectMenu extends Mixins() {
  @Prop()
  source: MovableTextBoxObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get selected(): MovableTextBoxInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: MovableTextBoxInputMethodKinds) {
    this.source.emitFocus();
    this.$nextTick(() => {
      this.source.inputMethodKind = value;
      this.source.setFocus();
    });
  }

  getButtonClass(kind: MovableTextBoxInputMethodKinds): string {
    return Enumerable.from(this.buttonClasses)
      .first(c => c.key === kind)
      .class;
  }

  isVisible(kind: MovableTextBoxInputMethodKinds): boolean {
    return !!this.getButtonClass(kind);
  }

  buttonClasses: { key: MovableTextBoxInputMethodKinds, class: string }[] = [
    { key: MovableTextBoxInputMethodKinds.None, class: "movable-text-object-menu-none" },
    { key: MovableTextBoxInputMethodKinds.FreeInput, class: "movable-text-object-menu-free" },
    { key: MovableTextBoxInputMethodKinds.MKSTemplate, class: "movable-text-object-menu-data" }, // TODO:アイコン差し替え.
    { key: MovableTextBoxInputMethodKinds.DynamicTemplate, class: "movable-text-object-menu-data" }, // TODO:アイコン差し替え.
  ];
}
